/* styled-components & other non-external style-related exports (like, say, a `headerHeight` var) go here */
import { font, colors, spacing, breakpoints } from '@chegg-ui/theme';
import { Link } from '@chegg-ui/link';
import styled from 'styled-components';
import { activeNavItemBorder } from './desktop';
var size = font.size,
    weight = font.weight;
export var NavWrap = styled.ul.withConfig({
  componentId: "sc-1m6mqz-0"
})(["display:flex;list-style:none;padding:0;margin:0;@media (max-width:", "){flex-direction:column;}"], breakpoints.md.max);
export var NavItem = styled.li.withConfig({
  componentId: "sc-1m6mqz-1"
})(["display:flex;@media (min-width:", "){margin:", " 0;border-right:", " solid 1px;&:last-of-type{border-right:none;}}"], breakpoints.lg.min, spacing.px12, colors.greyMedium);
export var NavLink = styled(Link).withConfig({
  componentId: "sc-1m6mqz-2"
})(["font-size:", ";color:", ";text-decoration:none;padding:0 ", ";font-weight:", ";white-space:nowrap;position:relative;&:visited{color:", ";}&:link,&:hover,&:visited,&:active{text-decoration:none;}@media (min-width:", "){", ";&:hover{&:before{height:5px;bottom:-6px;}}}@media (max-width:", "){padding:", " 0;flex-grow:1;&::before{content:'';display:", ";position:absolute;width:0.25rem;height:1.25rem;left:", ";top:", ";background-color:", ";}}"], size.px16, colors.dark, spacing.px16, weight.bold, colors.dark, breakpoints.lg.min, function (_ref) {
  var isActive = _ref.isActive;
  return activeNavItemBorder('calc(100% - 2rem)', isActive);
}, breakpoints.md.max, spacing.px16, function (props) {
  return props.isActive ? 'block' : 'none';
},
/* istanbul ignore next */
function (props) {
  return props.positionX && props.positionX < 0 ? "calc(-100vw + ".concat(Math.abs(props.positionX), "px)") : "-".concat(props.positionX, "px");
}, spacing.px12, colors.cheggOrange);